import {
     Icon, IconButton, LinearProgress, Pagination, Paper,
    Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow,
    tableCellClasses } from "@mui/material";
    import Grid from '@mui/material/Grid2';
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { styled } from '@mui/material/styles';

import { FerramentasDaListagem } from "../../shered/components";
import { Enviroment } from "../../shered/enviroments";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { IListagemDadosUsuario, UsuarioService } from "../../shered/services/api/usuario/UsuarioService";
import { useAuthContext } from "../../shered/contexts";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";

export const ListagemDeUsuarios: React.FC = () => {
    const { logout } = useAuthContext();
    const [searchParams, SetSearchParams] = useSearchParams();
    const { debounce } = useDebounce();
    const navigate = useNavigate();

    const [rows, setRows] = useState<IListagemDadosUsuario[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoadig] = useState(true);
    const [adm, setAdm] = useState(false);
    const [cod_Usuario, setCod_Usuario] = useState(0);
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const busca = useMemo(() => {
        return searchParams.get("busca") || "";
    }, [searchParams]);

    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "1");
    }, [searchParams]);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            padding: "8px "
        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td': {
            border: 0,
        },
        '&:last-child th': {
            border: 0,
            padding: "16px 10px ",
        },
    }));

    useEffect(() => {
        setIsLoadig(true);
        const user = CookieService.get("access_user");        
        setAdm(user.administrador);
        setCod_Usuario(user.codUsuario);        
        debounce(() => {

            let codigoUsuario = user.administrador ? "" : user.codUsuario;
            UsuarioService.getAllPaginado(pagina, codigoUsuario, busca)
                .then((result) => {
                    setIsLoadig(false);
                    const lst = result.data.dado;                    
                    setRows(lst);                 
                    setTotalCount(result.data.totalRegistros);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setIsLoadig(false);
                });
        });
    }, [pagina, busca, cod_Usuario]);

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            UsuarioService.deleteById(id)
                .then((result) => {
                    setRows(oldRows => [
                        ...oldRows.filter(oldRow => oldRow.codigo !== id),
                    ]);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Registro excluido com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });

                }).catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, codigo: number) => {
        //setDisable(false);
        const { name, value } = e.target;
        const list = [...rows] as IListagemDadosUsuario[];

        const newlist = list.map((item) =>
            item.codigo === codigo && name ? { ...item, [name]: value } : item
        );
        setRows(newlist);
    };

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
    };

    const handleRedirecionar = (codigo: number) =>{
        if (codigo > 0) {          
            let crypt = UtilidadeService.crypt(codigo.toString());
            navigate(`/adm/usuarios/detalhe/${crypt}`);
        }
    }

    const handleRedirecionarFinanceiro = (codigo: number) =>{
        if (codigo > 0) {          
            let crypt = UtilidadeService.crypt(codigo.toString());
            navigate(`/usuario/financeiro/${crypt}`);
        }
    }
    

    return (
        <LayoutBaseDePagina
            titulo="Listagem de usuários"
            barraDeFerramentas={<FerramentasDaListagem
                mostrarInputBusca={adm === true}
                mostrarBotaoNovo={adm === true}
                textoDaBusca={busca}
                aoClicarBotaoNovo={() => navigate('/adm/usuarios/detalhe/novo')}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {isLoading && (<Grid >
                <LinearProgress variant="indeterminate" />
            </Grid>)}
            <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell width={100}>Ações</StyledTableCell>
                            <StyledTableCell>Código</StyledTableCell>
                            <StyledTableCell>Nome</StyledTableCell>
                            {/* <StyledTableCell>Login</StyledTableCell> */}
                            <StyledTableCell>E-mail</StyledTableCell>
                            <StyledTableCell>Celular</StyledTableCell>
                            <StyledTableCell>Último Acesso</StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map(({ codigo, nome, login, email, dddCel, celular, dtUltimoAcesso, administrador }) => (
                            <StyledTableRow key={codigo}>
                                {adm === true || cod_Usuario == codigo ? (<StyledTableCell>
                                    <IconButton size="small" onClick={() => handleDelete(codigo)}>
                                        <Icon>delete</Icon>
                                    </IconButton>
                                    <IconButton size="small" onClick={() => handleRedirecionar(codigo)}>
                                        <Icon>edit</Icon>
                                    </IconButton>
                                    <IconButton size="small" onClick={() => handleRedirecionarFinanceiro(codigo)}>
                                        <Icon>attach_money</Icon>
                                    </IconButton>
                                </StyledTableCell>
                                ) : <StyledTableCell key={codigo}> </StyledTableCell>
                                }
                                <StyledTableCell>{codigo}</StyledTableCell>
                                <StyledTableCell>{nome}</StyledTableCell>
                                {/* <StyledTableCell>{login}</StyledTableCell> */}
                                <StyledTableCell>{email}</StyledTableCell>
                                <StyledTableCell>{dddCel === null || celular === null ? "" : `(${dddCel}) ${celular}`}</StyledTableCell>
                                <StyledTableCell>{dtUltimoAcesso === null ? "" : new Date(dtUltimoAcesso).toLocaleDateString("pt-Br")}</StyledTableCell>
                            </StyledTableRow>
                        ))
                        }
                    </TableBody>
                    {totalCount === 0 && !isLoading && (
                        <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                    )}
                    <TableFooter>
                        {isLoading && (
                            <StyledTableRow>
                                <StyledTableCell colSpan={6}>
                                    <LinearProgress variant="indeterminate" />
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                        {(totalCount > 0 && totalCount > Enviroment.LIMITE_DE_LINHAS) && (
                            <StyledTableRow >
                                <StyledTableCell  colSpan={2}>
                                    TOTAL: {totalCount}
                                </StyledTableCell>
                                <StyledTableCell colSpan={5} >
                                    <Pagination
                                        page={pagina} 
                                        count={Math.ceil(totalCount / Enviroment.LIMITE_DE_LINHAS)}
                                        onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}

                                    />
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableFooter>
                </Table>
            </TableContainer>
        </LayoutBaseDePagina>
    );
};